import React, { useState } from 'react';
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo, useGetURL } from 'helpers/urlFriendly';
import { useGetDisciplines } from 'helpers/commonCodes';
import MirsTable from 'components/general/table/Table.js';
import { useMemo } from 'react';
import { DisciplineMemo } from 'components/presentation/Discipline';
import { Link } from 'react-router-dom';
import { isParalympic } from 'helpers/utils';

export default function RecordsTable() {
    let params = useUrlFriendlyToParameters()
    const [paramsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'schedule')
    const getURL = useGetURL()

    let arrHasRecords = (isParalympic(params.mirs_competition) ? process.env.REACT_APP_PARAS_RECORDS_ARRAY : process.env.REACT_APP_RECORDS_ARRAY) || [];

    //copy parameters URL to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   
    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }

    paramsURL["mirs_event"] = "";
    paramsURL["mirs_date"] = "";

    //get disciplines from memory 
    let data = useGetDisciplines(paramsURL)
    data = data?.disciplines ? data?.disciplines?.filter(item => arrHasRecords.includes(item.code)) : []

    const tableColumns = useMemo(() =>
        [
            {
                id: 'Code',
                Header: <Label data={'HeaderDiscipline'} />,
                accessor: 'code',
                headerClassName: 'discipline-header',
                className: 'text-start fw-bold',
                Cell: (props) => {
                    const row = props.cell.row.original
                    return (<DisciplineMemo code={row?.code} description={row?.description} showDescription={true} />)
                }

            },
            {
                id: 'Link',
                Header: <Label data={'HeaderRecords'} />,
                accessor: 'code',
                className: 'text-start w-40',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let paramsURL = { ...params }
                    paramsURL["mirs_discipline"] = row?.code
                    let url = getURL(paramsURL, "records")
                    //let url = `/${paramsURL['mirs_competition']}/${paramsURL['mirs_language']}/records/${row?.code}`;

                    return (<Link to={url} ><Label data={'GoToPage'} /> </Link>)
                }

            },
        ], [data]
    )
    return (
        <MirsTable
            id={`mirs-table-records`}
            data={data}
            columns={tableColumns}
            showLoading={false}
            className={'mirs-records'}
            initialSortBy={[{ id: 'Code', desc: false }]}
        />
    );
};
